export default __webpack_public_path__ + "static/media/wal.93c91aa1.jpg";